

















































import { defineComponent, onMounted, reactive, toRefs, watch, computed } from '@vue/composition-api';
import { getSharePanelInfo } from '@services/share/photo';
import { serialize, isAndroid } from '@common/util';
import { sendLog, getShareCommonParams } from '@common/log';

const host = '//cdn-static.kwai.net/kos/s101/nlav11312/kwai-share/assets/share_panel';

export default defineComponent({
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        shareUrl: {
            type: String,
            default: '',
        },
    },
    emits: ['cancel'],
    setup(props, { root }: any) {
        const {
            initData: { query, title, photoId: pid, titleAppName, did, authorId: uid, isRtl, kpn },
            message: { localLang, pageConf },
        } = root.$store.state;

        const photoId = computed(() => {
            return root.$store.state.photoPageModule?.photoId || pid;
        });
        const authorId = computed(() => {
            return root.$store.state.photoPageModule?.authorId || uid;
        });

        const state: any = reactive({
            showToast: false,
            channelList: ['whatsapp', 'facebook', 'telegram', 'twitter'],
            capableList: ['copylink', 'install'],
            myCc: '',
            windowReference: null,
            telegramUrl: '',
            copylinkUrl: '',
        });

        const panelList = {
            whatsapp: {
                name: 'WhatsApp',
                ccName: 'WHATS_APP', // 分享渠道
                img: `${host}/icon_whatsapp.png`,
                getUrl: (text: string, link: string) => `https://wa.me?text=${`${text} ${link}`}`,
            },
            facebook: {
                name: 'Facebook',
                ccName: 'FACEBOOK',
                img: `${host}/icon_facebook.png`,
                getUrl: (text: string, link: string) => `https://www.facebook.com/sharer/sharer.php?u=${link}&quote=${text}`,
            },
            messenger: {
                name: 'Messenger',
                ccName: 'MESSENGER',
                img: `${host}/icon_messenger.png`,
                getUrl: (text: string, link: string) => `fb-messenger://share?link=${link}`,
            },
            telegram: {
                name: 'Telegram',
                ccName: 'TELEGRAM',
                img: `${host}/icon_telegram.png`,
                getUrl: (text: string, link: string) => `https://t.me/share/url?url=${link}&text=${text}`,
            },
            twitter: {
                name: 'Twitter',
                ccName: 'TWITTER',
                img: `${host}/icon_twitter.png`,
                // twitter path后面不能有/，否则在web版无法登陆，发布按钮无法点击
                getUrl: (text: string, link: string) => `https://twitter.com/intent/tweet?url=${link}&text=${text}`,
            },
            copylink: {
                name: localLang['2nd_share_panel_copylink'],
                ccName: 'COPY_LINK',
                img: `${host}/icon_copylink.png`,
                getUrl: (text: string, link: string) => `${text} ${decodeURIComponent(link)}`,
            },
            install: {
                name: localLang['2nd_share_panel_install']?.replace(/\$?\{(.*?)\}/, titleAppName) || '',
                ccName: titleAppName?.replace(/\s/, '')?.toUpperCase(),
            },
        };

        const second_share_id = `${did}_${new Date().getTime()}`;

        const copyText = async (url: string) => {
            if (state.showToast) return;
            const textarea = document.createElement('textarea');
            document.body.appendChild(textarea);
            textarea.style.position = 'absolute';
            textarea.style.opacity = '0';
            // 复制的内容
            textarea.value = url;

            textarea.select();
            document.execCommand('copy', true);
            textarea.remove();

            state.showToast = true;
            setTimeout(() => {
                state.showToast = false;
            }, 2000);

            installApp();
        };

        const getLogParams = () => {
            return {
                type: 'click',
                name: 'SHARE_EVENT',
                value: {
                    ...getShareCommonParams(query, 'SHARE_PHOTO_WEB_H5'),
                    author_id: authorId.value,
                    photo_id: photoId.value,
                    second_cc: query.second_cc,
                    second_device_id: query.second_device_id,
                    second_share_item_type: 'photo_share_H5_2nd_share',
                    second_share_id: query.second_share_id,
                    share_total_times: query.share_total_times || 1,
                    share_times: query.share_times,
                    cc: query.cc,
                    share_url: window.location.href,
                    my_cc: state.myCc,
                    my_share_device_id: did,
                    my_share_id: second_share_id,
                },
            };
        };

        const installApp = () => {
            root.$store.commit('jumpApp', {
                area: 'share_panel_install',
                logConfig: getLogParams(),
                scheme: `work/${photoId.value}`,
            });
        };
        
        const openWindow = (url: string) => {

            sendLog(getLogParams());

            if (isAndroid()) {
                window.open(url);
            } else if (state.windowReference) {
                state.windowReference.location = url;
            } else {
                window.location.href = url;
            }
        };

        const getBaseUrl = (channel: string) => {
            const { pathname, origin, host } = window.location;
            const params = {
                ...query,
                second_share_id,
                second_cc: panelList[channel].ccName,
                second_device_id: did,
                share_times: query.share_times ? +query.share_times + 1 : 2,
                
                // 这两个参数是给服务端用的
                second_share_item_type: 'photo',    // 这里目前只有视频页有二次分享，所以默认写的photo
                second_share_item_info: photoId.value,
            };
            const href = `${window.location.origin}/photo/${authorId.value}/${photoId.value}`;
            return `${href}?${serialize(params)}`;
        };

        const getShortUrl = async (channel: string) => {
            const link = getBaseUrl(channel);
            try {
                const res = await getSharePanelInfo({
                    kpn,
                    link,
                    share_channel: channel,
                    share_source: 'photo_share_H5_2nd_share',
                    share_uid: query.share_uid,
                    share_did: query.share_device_id || query.share_did,
                });
                if (res.result === 1) {
                    const { styleConfig, shortlink } = res || {};
                    const url = panelList[channel].getUrl(styleConfig?.description || title, encodeURIComponent(shortlink || link));
                    return url;
                }
            } catch (error) {
                console.error(error);
            }
            return panelList[channel]?.getUrl(title, encodeURIComponent(link));
        };

        const clickHandler = async (channel: string) => {
            state.myCc = panelList[channel]?.ccName;

            if (channel === 'install') {
                return installApp();
            }
            
            try {
                window.localStorage.setItem('SHARE_2ND', new Date().getTime());
            } catch (error) {
                console.error(error);
            }

            if (channel === 'telegram') {
                openWindow(state.telegramUrl);
                return;
            }

            if (channel === 'facebook' && !isAndroid()) {
                state.windowReference = window.open();
            }
            
            let url = '';
            if (isAndroid() || channel !== 'copylink') {
                url = await getShortUrl(channel);
            }
            
            if (channel === 'copylink') {
                copyText(!isAndroid() ? state.copylinkUrl : url);
            } else {
                openWindow(url);
            }
        };

        watch(() => props.visible, (val: boolean) => {
            if (val) {
                document.body.classList.add('body-hidden');
            } else {
                document.body.classList.remove('body-hidden');
            }
            root.$store.commit('setDialog', !val);
        });


        const getConfig = async () => {
            const list = state.channelList.slice();
            if (query.cc) {
                const index = list.findIndex(item => panelList[item]?.ccName === query.cc);

                if (index >= 0) {
                    const curr = list.splice(index, 1);
                    list.unshift(curr[0]);
                    state.channelList = list;
                }
            }
        };

        const getTelegramUrl = async () => {
            const url = await getShortUrl('telegram');
            state.telegramUrl = url;
        };

        const getCopylinkUrl = async () => {
            const url = await getShortUrl('copylink');
            state.copylinkUrl = url;
        };

        const checkShare2nd = () => {
            const localDate = localStorage.getItem('SHARE_2ND');

            // 间隔大于2s触发拉端
            if (localDate && new Date().getTime() - localDate > 2000) {
                installApp();
            }

            localStorage.removeItem('SHARE_2ND');
        };

        watch(() => props.visible, (val: boolean) => {
            if (val && !state.telegramUrl) {
                // Telegram不支持异步调起，需要提前把链接准备好
                getTelegramUrl();
                if (!isAndroid()) {
                    getCopylinkUrl();
                }
            }
        });

        onMounted(async () => {
            if (pageConf?.share2nd) {
                getConfig();
            }
            
            checkShare2nd();

            document.addEventListener('visibilitychange', () => {
                if (document.visibilityState === 'visible') {
                    checkShare2nd();
                }
            });
        });

        return {
            ...toRefs(state),
            isRtl,
            panelList,
            pannelTitle: localLang['2nd_share_panel_share_to'],
            copySuccess: localLang['2nd_share_copied'],
            clickHandler,
            kpn,
        };
    },
});
